/** 
 * Import Ionic and others 
 */
import { Component } from '@angular/core';
import { MenuController, NavController, Events, LoadingController } from 'ionic-angular';
import { AccountSignupPage } from '../account-signup/account-signup';

/**
 * Import providers
 */
// import { User } from '../../providers/user';

/**
 * Slide interface
 * 
 * @export
 * @interface Slide
 */
export interface Slide {
  title: string;
  description: string;
  image: string;
}

/**
 * TutorialPage Component
 * 
 * @export
 * @class TutorialPage
 */
@Component({
  selector: 'tutorial-page',
  templateUrl: 'tutorial.html',
  providers: []
})
export class TutorialPage {
  slides: Slide[];
  showSkip = true;

  constructor(
    public navCtrl: NavController,
    public menu: MenuController,
    public loading: LoadingController,
    public events: Events
  ) {
    this.slides = [
      {
        title: 'A simple app',
        description: '<h3>to keep you in action</h3>',
        image: 'assets/img/phone-1.png',
      },
      {
        title: 'Add',
        description: '<h3>your weekly schedule of tasks</h3>',
        image: 'assets/img/phone-2.png',
      },
      {
        title: 'Easy',
        description: '<h3>manage of data<br />view or delete tasks</h3>',
        image: 'assets/img/phone-3.png'
      }
    ];
  }

  startApp() {
    this.navCtrl.push(AccountSignupPage);
  }

  onSlideChangeStart(slider) {
    this.showSkip = !slider.isEnd;
  }
  ionViewDidEnter() {
    // the root left menu should be disabled on the tutorial page
    this.menu.enable(false);
  }

  ionViewWillLeave() {
    // enable the root left menu when leaving the tutorial page
    this.menu.enable(true);
  }
}


// WEBPACK FOOTER //
// ./src/pages/tutorial/tutorial.ts